/* eslint-disable import/prefer-default-export */

import axios from './axios';

export const getEstimateStatuses = ({ params } = {}) => axios.get(`estimate_statuses`, { params });